import { baseApi } from "../api/baseApi";
export const projectStatusesApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        refreshProjectStatuses: builder.mutation({
            query: (body) => ({
                url: "ProjectStatuses/refresh",
                method: "POST",
                body,
            }),
        }),
    }),
});
export const { useRefreshProjectStatusesMutation } = projectStatusesApi;
